import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import PendoTooltip from '../../../directives/tooltip/pendo-tooltip.js';
import PendoIcon from '../../icon/pendo-icon.vue.js';
import PendoButton from '../../button/pendo-button.vue.js';

var script = {
  name: 'PendoActionsOption',
  components: {
    PendoButton,
    PendoIcon
  },
  directives: {
    PendoTooltip
  },
  inject: ['multiselect'],
  props: {
    option: {
      type: [Object, String],
      required: true
    },
    index: {
      type: Number,
      default: -1
    },
    actions: {
      type: [Array, Boolean],
      default: () => [{
        type: 'edit',
        tooltip: 'Edit',
        icon: {
          type: 'edit'
        }
      }, {
        type: 'copy',
        tooltip: 'Copy',
        icon: {
          type: 'copy'
        }
      }, {
        type: 'delete',
        tooltip: 'Delete',
        icon: {
          type: 'trash-2'
        }
      }]
    }
  },
  data() {
    return {
      useInternalHoverListener: false,
      forceShowActions: false,
      tooltipTimeout: null
    };
  },
  computed: {
    tooltipConfig() {
      const isOptionSelected = this.multiselect.isOptionSelected(this.option);
      if (isOptionSelected) {
        return false;
      }
      const isHovered = this.multiselect.showPointer && this.multiselect.pointer === this.index;
      if (this.option && this.option.tooltip && isHovered) {
        return _objectSpread2(_objectSpread2({
          multiline: true,
          arrow: true,
          html: false
        }, this.option.tooltip), {}, {
          trigger: 'manual'
        });
      }
      return false;
    },
    listeners() {
      if (this.useInternalHoverListener) {
        return _objectSpread2(_objectSpread2({}, this.$listeners), {}, {
          mouseenter: this.toggleHoverStatus,
          mouseleave: this.toggleHoverStatus
        });
      }
      return this.$listeners;
    },
    label() {
      return this.multiselect.getOptionLabel(this.option);
    },
    icon() {
      return _objectSpread2({
        size: 14
      }, this.option.icon);
    },
    showActions() {
      if (this.option.disabled) {
        return false;
      }
      if (this.useInternalHoverListener) {
        return this.actions && this.forceShowActions;
      }
      return this.actions && this.multiselect.showPointer && this.multiselect.pointer === this.index;
    }
  },
  watch: {
    tooltipConfig(config) {
      clearTimeout(this.tooltipTimeout);
      if (config) {
        this.tooltipTimeout = setTimeout(() => {
          if (this.tooltipConfig) {
            this.$refs.label._tooltip.show();
          }
        }, 300);
        return;
      }
      this.$refs.label._tooltip.hide();
    }
  },
  mounted() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.style.paddingRight = '8px';
      this.useInternalHoverListener = !!this.$el.closest('.pendo-multiselect__header') || !!this.$el.closest('.pendo-multiselect__before-list');
    }
  },
  methods: {
    toggleHoverStatus() {
      if (!this.useInternalHoverListener) {
        return;
      }
      this.multiselect.pointerSet(-1);
      this.forceShowActions = !this.forceShowActions;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-actions-option.vue2.js.map
